/**
 * Copyright IBM Corp. 2022, 2026
 */

// TODO: consider adding this to HdsTabs
'use client'
import { AnimatePresence, m, type Variants } from 'motion/react'
import { Tabs, useTabsContext } from '@hashicorp/mds-react/components'
import type { ReactNode } from 'react'
import s from './style.module.css'

const variants: Variants = {
	visible: {
		opacity: 1,
		transition: {
			opacity: {
				duration: 0.3,
				delay: 0.3,
			},
		},
	},
	hidden: {
		opacity: 0,
		transition: {
			duration: 0.3,
		},
	},
}

interface AnimatedPanelProps {
	index: number
	children: ReactNode
}

export const AnimatedPanel = ({ index, children }: AnimatedPanelProps) => {
	const { selectedTabIndex } = useTabsContext()
	const isActive = selectedTabIndex === index

	return (
		<AnimatePresence>
			{isActive && (
				<m.div
					key={index}
					className={s.panelWrapper}
					variants={variants}
					initial="hidden"
					animate="visible"
					exit="hidden"
				>
					<Tabs.Panel className={s.panel}>{children}</Tabs.Panel>
				</m.div>
			)}
		</AnimatePresence>
	)
}
